var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-popconfirm" },
    [
      _c(
        "v-popups",
        {
          ref: "popups",
          attrs: {
            "custom-style": { maxWidth: _vm.maxWidth },
            "show-arrow": _vm.showArrow,
            position: _vm.position,
            trigger: "click",
            transition: _vm.transition,
            "open-delay": _vm.openDelay,
            "close-delay": _vm.closeDelay,
            "click-outside-to-hide": _vm.clickOutsideToHide,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "reference",
                fn: function () {
                  return [_vm._t("reference")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _c(
            "div",
            { staticClass: "v-popconfirm__box" },
            [
              _vm._t("default", function () {
                return [
                  _c("div", { staticClass: "v-popconfirm__main" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "v-popconfirm__title",
                          { "has-icon": _vm.icon },
                        ],
                      },
                      [_vm._v(" " + _vm._s(_vm.title) + " ")]
                    ),
                    _c("i", { class: ["v-popconfirm__icon", _vm.icon] }),
                  ]),
                ]
              }),
              _vm.showConfirm || _vm.showCancel
                ? _c("div", { staticClass: "v-popconfirm__footer" }, [
                    _c(
                      "div",
                      { staticClass: "v-popconfirm__button-group" },
                      [
                        _vm.showCancel
                          ? _c(
                              "v-button",
                              {
                                staticClass: "v-popconfirm__button-item",
                                attrs: {
                                  type: _vm.cancelButtonType,
                                  size: "S",
                                },
                                on: { click: _vm.handleCancel },
                              },
                              [_vm._v(_vm._s(_vm.cancelButtonText))]
                            )
                          : _vm._e(),
                        _vm.showConfirm
                          ? _c(
                              "v-button",
                              {
                                staticClass: "v-popconfirm__button-item",
                                attrs: {
                                  type: _vm.confirmButtonType,
                                  size: "S",
                                },
                                on: { click: _vm.handleConfirm },
                              },
                              [_vm._v(_vm._s(_vm.confirmButtonText))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }